import { z } from 'zod';
import { uuidSchema, localeSchema } from './common.js';
export const transcriptionRequestSchema = z.object({
    /** Asset uploaded via /media/upload-intents with purpose AI_INPUT, or inline base64. */
    assetId: uuidSchema.optional(),
    audioBase64: z
        .string()
        .max(10 * 1024 * 1024)
        .optional(),
    mimeType: z.string().max(100).optional(),
    language: localeSchema.optional(),
    /** Hint so the server can bias towards the cooking-command grammar. */
    context: z.enum(['command', 'dictation']).default('dictation'),
});
export const transcriptionResponseSchema = z.object({
    text: z.string(),
    language: z.string().nullable(),
    provider: z.string(),
    durationMs: z.number().int().nullable(),
    generationId: uuidSchema.nullable(),
});
/**
 * Constrained cooking-mode command grammar. Parsing happens on the client first so
 * commands work offline; the server offers the same parser for transcribed audio.
 */
export const voiceCommandSchema = z.discriminatedUnion('type', [
    z.object({ type: z.literal('NEXT_STEP') }),
    z.object({ type: z.literal('PREVIOUS_STEP') }),
    z.object({ type: z.literal('REPEAT') }),
    z.object({ type: z.literal('GO_TO_STEP'), step: z.number().int().positive() }),
    z.object({ type: z.literal('HOW_MUCH'), ingredient: z.string() }),
    z.object({
        type: z.literal('START_TIMER'),
        seconds: z.number().int().positive(),
        label: z.string().nullable(),
    }),
    z.object({ type: z.literal('ADD_NOTE'), note: z.string() }),
    z.object({ type: z.literal('MARK_STEP_COMPLETE') }),
    z.object({ type: z.literal('PAUSE_LISTENING') }),
    z.object({ type: z.literal('READ_STEP') }),
    z.object({ type: z.literal('SHOW_INGREDIENTS') }),
    z.object({ type: z.literal('UNKNOWN'), transcript: z.string() }),
]);
/** Commands that mutate data must be confirmed by the user. */
export const DESTRUCTIVE_VOICE_COMMANDS = new Set(['ADD_NOTE']);
//# sourceMappingURL=speech.js.map